import { render, staticRenderFns } from "./addChapter.vue?vue&type=template&id=3a2f88fb&scoped=true&"
import script from "./addChapter.vue?vue&type=script&lang=js&"
export * from "./addChapter.vue?vue&type=script&lang=js&"
import style0 from "./addChapter.vue?vue&type=style&index=0&id=3a2f88fb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2f88fb",
  null
  
)

export default component.exports